import { render, staticRenderFns } from "./PracticeChooseModePopup.vue?vue&type=template&id=a39c1328&scoped=true"
import script from "./PracticeChooseModePopup.vue?vue&type=script&lang=js"
export * from "./PracticeChooseModePopup.vue?vue&type=script&lang=js"
import style0 from "./PracticeChooseModePopup.vue?vue&type=style&index=0&id=a39c1328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39c1328",
  null
  
)

export default component.exports